import registrationSettings from './registrationSettings';

export default registrationSettings;
